// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__11ATH","right":"styles_right__3ZAtO"};